import { StyleSheet } from 'aphrodite'

import list from './list'
import group from './group'
import headers from './headers'
import form from './form'

export default {
  list: StyleSheet.create(list),
  group: StyleSheet.create(group),
  headers: StyleSheet.create(headers),
  form: StyleSheet.create(form)
}



// WEBPACK FOOTER //
// ./src/components/User/partials/GroupForm/style/ColorBlind/index.js